export const API_PATH_ApiCreateCompanyDelete = '/services/auth-create-company';
